<template>
  <AdminModal
    :confirm-button-title="`${this.selected ? '수정' : '등록'}`"
    :modal-title="`${this.selected ? '오프라인 수강 신청 수정' : '오프라인 수강 신청 등록'}`"
    :is-open="isOpen" 
    :confirm="confirm"
    :close="close"
    modal-size="lg"
    name="offlineClassApplicationModal"
  >
    <div class="py-2 px-2">
      <b-row class="my-2">
        <b-form-group label="상품명" label-cols-sm="3" label-size="sm">
          <b-form-input
            class=" mr-sm-2 md-4"
            placeholder="상품명을 입력해주세요."
            v-model="title"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="상품 가격" label-cols-sm="3" label-size="sm">
          <b-form-input
            type="number"
            class=" mr-sm-2 md-4"
            placeholder="가격을 입력하세요."
            v-model="amount"
            :disabled="!!id"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2" >
        <b-form-group label="월별 판매 제한" label-cols-sm="3" label-size="sm">
          <b-form-input
            type="number"
            class=" mr-sm-2 md-4"
            v-model="monthlyLimitCount"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="안내사항" label-cols-sm="3" label-size="sm">
          <b-form-textarea
            v-model="content"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="노출 여부" label-cols-sm="3" label-size="sm">
          <b-form-radio-group
            v-model="publishStatus"
            :options="publishOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="판매 일자(기간내 상품 구매수로 마감 처리)" label-cols-sm="3" label-size="sm">
          <div class="inline-flex justify-start items-center w-full gap-2">
            <VueDatePicker
              v-model="startedAt"
              format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              placeholder="시작일자"
              auto-apply
            />
            <span>~</span>
            <VueDatePicker
              v-model="endedAt"
              format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              placeholder="종료일자"
              auto-apply
            />
          </div>
        </b-form-group>
      </b-row>
    </div>
  </AdminModal>
</template>

<script>
import api from "@/api/api";
import AdminModal from "@/components/modals/AdminModal.vue";
import moment from "moment/moment";
import {mapActions} from "vuex";

export default {
  name: "OfflineClassApplicationModal",
  components: {AdminModal},
  props: ['isOpen', 'close', 'selected', 'reload'],
  data(){
    return {
      id: null,
      title: '',
      amount: 0,
      content: "",
      publishStatus: "PUBLISHED",
      monthlyLimitCount: 0,
      startedAt: moment().set({ hour: 0, minute: 0, second: 0}).toDate(),
      endedAt: moment().add(12, 'days').set({ hour: 12, minute: 59, second: 59}).toDate(),
      publishOptions: [
        { item: "PUBLISHED", name: '노출' },
        { item: "UNPUBLISHED", name: '비노출' },
      ],
    }
  },
  mounted() {
    if (this.selected) {
      this.id = this.selected.id
      this.title = this.selected.title
      this.amount = this.selected.amount
      this.content = this.selected.content
      this.publishStatus = this.selected.status
      this.monthlyLimitCount = this.selected.monthlyLimitCount
      this.startedAt = this.selected.startedAt ? moment(this.selected.startedAt).toDate() : null
      this.endedAt =  this.selected.endedAt ? moment(this.selected.endedAt).toDate() : null
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    validate(){
      let errorMessage = ''
      if (this.title.length === 0){
        errorMessage = '상품명을 입력하세요.'
      }
      
      if (this.startedAt && this.endedAt && this.startedAt >= this.endedAt) {
        errorMessage = '시작일자는 종료일자보다 클 수 없습니다.'
      }

      if (errorMessage.length > 0) {
        this.$toast.error(errorMessage,
          {
            position: "top-right",
            duration: 2000
          })
        return false
      } else {
        return true
      }
    },
    update(){
      if(this.validate()) {
        api.offlineClassApplication.update({
          id: this.id,
          title: this.title,
          status: this.publishStatus,
          monthlyLimitCount: this.monthlyLimitCount || 0,
          content: this.content,
          startedAt: this.startedAt ? moment(this.startedAt).format("YYYY-MM-DD HH:mm:ss") : null,
          endedAt: this.endedAt ? moment(this.endedAt).format("YYYY-MM-DD HH:mm:ss") : null,
        }, () => {
          this.reload()
          this.close()
        }, error => {
          alert(error.message)
        })
      }
    },
    save(){
      if(this.validate()) {
        api.offlineClassApplication.save({
          title: this.title,
          amount: this.amount,
          status: this.publishStatus,
          monthlyLimitCount: this.monthlyLimitCount || 0,
          content: this.content,
          startedAt: this.startedAt ? moment(this.startedAt).format("YYYY-MM-DD HH:mm:ss") : null,
          endedAt: this.endedAt ? moment(this.endedAt).format("YYYY-MM-DD HH:mm:ss") : null,
        }, () => {
          this.reload()
          this.close()
        }, error => {
          alert(error.message)
        })
      }
    },
    confirm() {
      if(!this.validate()) {
        return
      }
      this.openModal({
        type: 'confirm',
        isOpen: true,
        title: `${this.id ? "오프라인 수업 신청 수정" : "오프라인 수업 신청 생성"}`,
        html: `${
          this.startedAt === null && this.endedAt === null
            ? "시작일자와 종료일자가 모두 설정되지 않은 경우, 전체 판매 갯수를 기준으로 마감됩니다."
            : this.startedAt === null
              ? "시작일자가 설정되지 않은 경우, 현재까지 판매된 상품의 갯수를 기준으로 판매 제한 수를 초과하지 않는 동안 구매가 가능합니다."
              : this.endedAt === null
                ? "종료일자가 설정되지 않은 경우, 시작일자로부터 판매된 상품의 갯수를 기준으로 판매 제한 수를 초과하지 않는 동안 구매가 가능합니다."
                : "설정된 시작일자와 종료일자 내에서 판매된 상품의 갯수가 판매 제한 수를 초과하지 않는 경우에만 구매할 수 있습니다."
        }`,
        confirm: () => {
          if (this.id) {
            this.update()
          } else {
            this.save()
          }
        },
      });
    }
  },
}
</script>

<style scoped>

</style>